import { getKmlSvg } from '@atom/map';
import { Checkbox } from '@atom/mui';
import type { KmlLayer } from '@atom/types/map';
import { toggleFromSet } from '@atom/utilities/setUtilities';

import { useMapLayers } from '../MapPortalDataProvider';

import classes from './filterPanel.module.css';

type KmlLayerRowProps = {
  layer: KmlLayer;
};

const KmlLayerRow = ({ layer }: KmlLayerRowProps) => {
  const { layers, setFilter } = useMapLayers();
  const { geospatialLayers: enabled, kmlLayerIds } = layers;

  const icon = getKmlSvg(layer.markerId);

  return (
    <div className={classes.sectionFilterRow}>
      <Checkbox
        edge="start"
        checked={kmlLayerIds.has(layer.id)}
        onChange={() =>
          setFilter('kmlLayerIds', toggleFromSet(kmlLayerIds, layer.id))
        }
        disabled={!enabled}
        data-cy={`dashboardGeospatialFilter-${layer.name}`}
      />
      {icon && <img className={classes.kmlRowIcon} src={icon} alt="" />}
      <span className={classes.sectionFilterRowText}>{layer.name}</span>
    </div>
  );
};

export default KmlLayerRow;
